import { ConfiguracionesEmpresa } from "@pcgerente-node/pcg-comun";
import { CONFIGURACION_EMPRESA } from "@pcgerente-node/pcg-comun/dist/DTOs";
import axios, { AxiosResponse } from "axios";
import { baseURL, headers } from "../redux/helpersRedux";
import { store } from "../redux/store";
import {IApiResponse} from "@pcgerente-node/pcg-comun";

/**busca la CONFIGURACION_EMPRESA por la descripcion*/
export async function CEL<T>(descricionConf:ConfiguracionesEmpresa): Promise<T> {
    const configuracion = await axios.get(`${baseURL}CONFIGURACION_EMPRESA?descripcion=${descricionConf}`,headers)
    .then((res: AxiosResponse<IApiResponse<CONFIGURACION_EMPRESA[]>>) => res.data )
    .then(res => {
        if(res.error || res.companion?.length === 0){
            throw new Error("No se pudo recuperar la configuracion empresa: " + descricionConf)
        }  
        return res.companion!![0]
    })

    return configuracion?.valor as T;
}

export interface coordenadas{
    latitud?: number;
    longitud?: number;
    cargando: boolean
}
/**Intenta obtener las coordenadas actuales del dispositivo, si no la encuentra arroja un mensaje de Error */
export const obtenerCoordenadas = (): Promise<coordenadas> => {
    return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
            return reject(new Error("No se pudo acceder a la ubicación del dispositivo"));
        }

        const options: PositionOptions = {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 0
        };

        const successCallback = (pos: GeolocationPosition) => {
            const { latitude, longitude } = pos.coords;
            if (latitude == null || longitude == null) {
                reject(new Error("No se pudo obtener la ubicación"));
            } else {
                resolve({ latitud: latitude, longitud: longitude, cargando: false });
            }
        };

        const errorCallback = (error: GeolocationPositionError) => {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    reject(new Error("El usuario denegó el permiso para acceder a la ubicación"));
                    break;
                case error.POSITION_UNAVAILABLE:
                    reject(new Error("No se pudo obtener la ubicación del dispositivo"));
                    break;
                case error.TIMEOUT:
                    reject(new Error("La obtención de la ubicación tardó demasiado"));
                    break;
                default:
                    reject(new Error("Error desconocido de geolocalización"));
            }
        };

        navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options);
    });
};


var ultimoTap = Date.now()
/**Manejamos el doble click que funciona tanto para Móvil y PC*/
export function HayDobleTap(): boolean{
    let retorno = false
    const tiempoMaximoEntreTaps = 300// milisegundos
    const ahora = Date.now();
    if (ahora - ultimoTap < tiempoMaximoEntreTaps) {
        //Hay doble Tap!!!
        retorno = true
    }
    ultimoTap = ahora;
    return retorno
}

export class ArchivoImagen {
    constructor(_file: File, _url: string){
        this.archivo = _file
        this.urlLocal = _url
    }
    public archivo: File
    public urlLocal: string
}



export class ReduxHelper{
    private static ObtenerUsuarioActual(){
       return store.getState().auth.usuarioActual._ItemActivo
    }

    public static IdUsuario(){
        return this.ObtenerUsuarioActual().id
    }
    public static IdCiudadUsuario(){
        return this.ObtenerUsuarioActual().idCiudad??null;
    }
    public static IdBodegaUsuario(){
        return this.ObtenerUsuarioActual().idBodega??null;
    }
};
